import axios from 'axios';
import { FIRST_PAGE, PAGE_SIZE_250 } from '../../services/pagination-service';

const advancedSearchEndpoint = '/ordergrid/shipmentmode/advancedsearch';
export const getAdvancedSearchOrders = (
  filters,
  pageNumber = FIRST_PAGE,
  pageSize = PAGE_SIZE_250,
  orderBy = 'orderNumber',
  orderByDirection = 'descending',
) => {
  const getOrders = axios
    .post(advancedSearchEndpoint, {
      filter: {
        ...filters,
      },
      page: {
        pageNumber,
        pageSize,
      },
      orderBy,
      orderByDirection,
    })
    .then((response) => {
      const { data = { orders: [] } } = response;
      return data;
    });

  return getOrders;
};
